import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { Link } from 'react-router-dom';
import './style.css';
import { convertToCurrency, convertToDiscount, convertToVNDate } from '../../helpers';

export default function ProductVertical(props = {}) {
  const { path, promotion, type, images, title, createdAt, summary, currentPrice, oldPrice, discountRate } = props;

  return (
    <Link to={path}>
      <div className="product-item">
        <div className="product-tag">{type}</div>
        <div className={classNames("thumbnail", promotion ? "promotion-code" : '')}>{images}</div>
        <div className={classNames("product-info", promotion ? "promotion-text" : '')}>
          <div className={promotion ? "promotion-code-title" : "product-title"}>{title}</div>
          {!promotion &&
            <>
              {createdAt ? <div className="product-sub-title">{convertToVNDate(createdAt)}</div> : null}
              {summary ? <div className="product-summary">{summary}</div> : null}
              {currentPrice
                ? <div className="price-discount">
                  <div className="product-price__current-price">{convertToCurrency(currentPrice)}</div>
                  <div className="product-price__list-price">{convertToCurrency(oldPrice)}</div>
                  <div className="price-discount__discount">{convertToDiscount(discountRate)}</div>
                </div>
                : null}
            </>}
        </div>
      </div>
    </Link>
  )
}

ProductVertical.propTypes = {
  path: PropTypes.string.isRequired,
  promotion: PropTypes.bool,
  type: PropTypes.string,
  images: PropTypes.node,
  title: PropTypes.string,
  date: PropTypes.string,
  summary: PropTypes.string,
  currentPrice: PropTypes.number,
  oldPrice: PropTypes.number,
  discountRate: PropTypes.number,
}